module.exports = __webpack_public_path__ + "static/img/icon-zwfw2x.8da4e667.png";